module.exports = __webpack_public_path__ + "img/info_atendimento.7212dc94.svg";